import { defineMessages } from "react-intl";
import { ReportType } from "./index";

export const reportFilterMessages = defineMessages({
  startDate: {
    id: "report.startDate",
    defaultMessage: "Start date"
  },
  endDate: {
    id: "report.endDate",
    defaultMessage: "End date"
  },
  groupDateBy: {
    id: "report.groupDateBy",
    defaultMessage: "Date type"
  },
  dateSearchCriteria: {
    id: "report.dateSearchCriteria",
    defaultMessage: "Group periods"
  },
  groupByEntity: {
    id: "report.groupByEntity",
    defaultMessage: "Group properties"
  },
  currency: {
    id: "report.currencyFilter",
    defaultMessage: "Currency"
  },
  order: {
    id: "report.order",
    defaultMessage: "Order {index}"
  },
  filter: {
    id: "report.filter",
    defaultMessage: "Filter"
  },
  bookingDate: {
    id: "report.bookingDate",
    defaultMessage: "Booking date"
  },
  checkIn: {
    id: "report.checkIn",
    defaultMessage: "Check-in"
  },
  checkOut: {
    id: "report.checkOut",
    defaultMessage: "Check-out"
  },
  perDay: {
    id: "report.perDay",
    defaultMessage: "Per day"
  },
  perMonth: {
    id: "report.perMonth",
    defaultMessage: "Per month"
  },
  perYear: {
    id: "report.perYear",
    defaultMessage: "Per year"
  },
  allPeriod: {
    id: "report.allPeriod",
    defaultMessage: "All period"
  },
  byProperty: {
    id: "report.byProperty",
    defaultMessage: "By property"
  },
  byPartner: {
    id: "report.byPartner",
    defaultMessage: "By partner"
  },
  byGroup: {
    id: "report.byGroup",
    defaultMessage: "By group"
  },
  total: {
    id: "report.total",
    defaultMessage: "Total"
  },
  original: {
    id: "report.original",
    defaultMessage: "Original"
  },
  asc: {
    id: "report.asc",
    defaultMessage: "Asc"
  },
  desc: {
    id: "report.desc",
    defaultMessage: "Desc"
  },
  concept: {
    id: "report.concept",
    defaultMessage: "Concept"
  },
  affiliate: {
    id: "report.affiliate",
    defaultMessage: "Agent"
  },
  promoTickers: {
    id: "report.promoTickers",
    defaultMessage: "Promotions"
  },
  promoCode: {
    id: "report.promoCode",
    defaultMessage: "Prom.code"
  },
  extras: {
    id: "report.extras",
    defaultMessage: "Extras"
  },
  country: {
    id: "report.country",
    defaultMessage: "Country"
  },
  accommodation: {
    id: "report.accommodation",
    defaultMessage: "Ticker"
  },
  accommodationConf: {
    id: "report.accommodationConf",
    defaultMessage: "Capacity"
  },
  conditionName: {
    id: "report.conditionName",
    defaultMessage: "Condition"
  },
  board: {
    id: "report.board",
    defaultMessage: "Board"
  },
  dynamicPriceTickers: {
    id: "report.dynamicPriceTickers",
    defaultMessage: "Dynamic prices"
  },
  origin: {
    id: "report.origin",
    defaultMessage: "Origin"
  },
  mode: {
    id: "report.mode",
    defaultMessage: "Mode"
  },
  paymentTypes: {
    id: "report.paymentType",
    defaultMessage: "Payment type"
  },
  status: {
    id: "report.status",
    defaultMessage: "State"
  },
  all: {
    id: "report.all",
    defaultMessage: "All"
  },
  cc_vault: {
    id: "report.cc_vault",
    defaultMessage: "State"
  },
  pos: {
    id: "report.pos",
    defaultMessage: "State"
  },
  tr: {
    id: "report.tr",
    defaultMessage: "State"
  },
  token_vault: {
    id: "report.token_vault",
    defaultMessage: "State"
  },
  pay_no_pain_v2: {
    id: "report.pay_no_pain_v2",
    defaultMessage: "State"
  },
  pci_proxy: {
    id: "report.pci_proxy",
    defaultMessage: "State"
  },
  paypal_ec: {
    id: "report.paypal_ec",
    defaultMessage: "State"
  },
  pay_no_pain_proxy: {
    id: "report.pay_no_pain_proxy",
    defaultMessage: "State"
  },
  without_card: {
    id: "report.without_card",
    defaultMessage: "Without card"
  },
  reservation_request: {
    id: "report.reservation_request",
    defaultMessage: "Reservation request"
  },
  paycomet: {
    id: "report.paycomet",
    defaultMessage: "Paycomet"
  },
  paycomet_ivr: {
    id: "report.paycomet_ivr",
    defaultMessage: "Paycomet IVR"
  },
  checkout_pnp: {
    id: "report.checkout_pnp",
    defaultMessage: "Checkout PNP"
  },
  adyen: {
    id: "report.adyen",
    defaultMessage: "Adyen"
  },
  sibs: {
    id: "report.sibs",
    defaultMessage: "Sibs"
  },
  freedom_pay: {
    id: "report.freedom_pay",
    defaultMessage: "FreedomPay"
  },
  stripe: {
    id: "report.stripe",
    defaultMessage: "Stripe"
  },
  confirmed: {
    id: "report.confirmed",
    defaultMessage: "Confirmed"
  },
  pending: {
    id: "report.pending",
    defaultMessage: "Confirmed"
  },
  failed: {
    id: "report.failed",
    defaultMessage: "Confirmed"
  },
  notConfirmed: {
    id: "report.notConfirmed",
    defaultMessage: "Not confirmed"
  },
  expired: {
    id: "report.expired",
    defaultMessage: "Timed out"
  },
  cancelled: {
    id: "report.cancelled",
    defaultMessage: "Cancelled"
  },
});

export const reportMessages = defineMessages({
  entityName_DEFAULT: {
    id: "report.title.default",
    defaultMessage: "Bookings statistics"
  },
  entityName_CONCEPT: {
    id: "report.title.concept",
    defaultMessage: "Bookings by concept"
  },
  entityName_STATUS: {
    id: "report.title.status",
    defaultMessage: "Bookings by state"
  },
  period: {
    id: "report.period",
    defaultMessage: "Period"
  },
  property: {
    id: "report.property",
    defaultMessage: "Property"
  },
  group: {
    id: "report.group",
    defaultMessage: "Group"
  },
  partner: {
    id: "report.partner",
    defaultMessage: "Partner"
  },
  avgStay: {
    id: "report.avgStay",
    defaultMessage: "Stay(d)"
  },
  avgAdvance: {
    id: "report.avgAdvance",
    defaultMessage: "Adv(d)"
  },
  totalReservations: {
    id: "report.totalReservations",
    defaultMessage: "Res"
  },
  totalAmount: {
    id: "report.totalAmount",
    defaultMessage: "$Res"
  },
  avgAmount: {
    id: "report.avgAmount",
    defaultMessage: "$xR"
  },
  totalRoomsNight: {
    id: "report.totalRoomsNight",
    defaultMessage: "RN's"
  },
  avgRoomsNight: {
    id: "report.avgRoomsNight",
    defaultMessage: "$xRN"
  },
  avgOccupantNight: {
    id: "report.avgOccupantNight",
    defaultMessage: "$xP"
  },
  currency: {
    id: "report.currency",
    defaultMessage: "Cur"
  },
  totalSum: {
    id: "report.totalSum",
    defaultMessage: "Total sum"
  },
  average: {
    id: "report.average",
    defaultMessage: "Average"
  },
  consult: {
    id: "report.consult",
    defaultMessage: "Consult"
  },
  exportToExcel: {
    id: "report.exportToExcel",
    defaultMessage: "Export to Excel"
  },
  resultsPerPage: {
    id: "report.resultsPerPage",
    defaultMessage: "Results per page"
  },
  tableNoItems: {
    id: "report.tableNoItems",
    defaultMessage: "Results are not found",
  },
  groupDateBy: {
    id: "report.groupDateBy",
    defaultMessage: "Date type"
  },
  dateSearchCriteria: {
    id: "report.dateSearchCriteria",
    defaultMessage: "Results are not found",
  },
  groupByEntity: {
    id: "report.groupByEntity",
    defaultMessage: "Group properties"
  },
  order_0: {
    id: "report.orderOne",
    defaultMessage: "Order 1"
  },
  order_1: {
    id: "report.orderTwo",
    defaultMessage: "Order 2"
  },
  order_2: {
    id: "report.orderThree",
    defaultMessage: "Order 3"
  },
  concept: {
    id: "report.concept",
    defaultMessage: "Concept"
  },
  paymentTypes: {
    id: "report.paymentType",
    defaultMessage: "Payment type"
  },
  status: {
    id: "report.status",
    defaultMessage: "State"
  },
});

export const reportTooltipMessages= defineMessages({
  avgStay: {
    id: "report.avgStayTooltip",
    defaultMessage: "Average stay (nights)"
  },
  avgAdvance: {
    id: "report.avgAdvanceTooltip",
    defaultMessage: "Average booking advance (days)"
  },
  totalReservations: {
    id: "report.totalReservationsTooltip",
    defaultMessage: "Number of bookings in the period"
  },
  totalAmount: {
    id: "report.totalAmountTooltip",
    defaultMessage: "Total amount of bookings in the period"
  },
  avgAmount: {
    id: "report.avgAmountTooltip",
    defaultMessage: "Average amount per booking"
  },
  totalRoomsNight: {
    id: "report.totalRoomsNightTooltip",
    defaultMessage: "Total room nights in the period"
  },
  avgRoomsNight: {
    id: "report.avgRoomsNightTooltip",
    defaultMessage: "Average amount per room night"
  },
  avgOccupantNight: {
    id: "report.avgOccupantNightTooltip",
    defaultMessage: "Average amount per person per night"
  },
  currency: {
    id: "report.currencyTooltip",
    defaultMessage: "Report currency"
  },
})